<template>
  <div>
    <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog persistent scrollable v-model="isShowDownloadPopup"
      :max-width="process_type === 'upload' ? '900px' : '820px'"> 
      <v-card>
        <v-toolbar color="primary" dark>
          <div class="header-flx">
            <v-toolbar-title class="ma-2">Exports </v-toolbar-title>
            <div>


            </div>
          </div>

        </v-toolbar>
        <div class="select_type"><v-select v-model="process_type" :items="tabs" @change="typechange($event)"></v-select>
        </div>
        <v-card-text v-if="process_type === 'upload'" class="hide-v-card">
          <div class="scroll-container">
            <v-table>
              <thead>
                <tr>
                  <th class="header-cell">Id</th>
                  <th class="header-cell">Template Name</th>
                  <th class="header-cell">Type</th>
                  <th class="header-cell">List Id</th>
                  <th class="header-cell">Status</th>
                  <th class="header-cell">Created at</th>
                  <th class="header-cell">Skip Data</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="downloadItems.length === 0">
                  <td colspan="5" style="text-align: center;">No data available</td>
                </tr>
                <tr v-for="(item, index) in downloadItems" :key="index">
                  <td class="row-cell">{{ item.item.id }}</td>
                  <td class="row-cell">{{ item.templateName }}</td>
                  <td class="row-cell">{{ item.type }}</td>
                  <td class="row-cell">{{ item.list_id }}</td>
                  <td class="row-cell">
                    {{

                      item.flag == 2
                        ? "completed"
                        : "processing"
                    }}
                  </td>
                  <td class="row-cell">{{ item.item.created_at }}</td>
                  <td class="row-cell">
                    <v-icon title="Download Leads" :disabled="item.flag == 2 ? false : true" small
                      @click="donwnloadfile(item)" class="fas fa-download1">
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </v-card-text>
        <v-card-text v-else class="hide-v-card">
          <div class="scroll-container">
            <v-table>
              <thead>
                <tr>
                  <th class="header-cell">Id</th>
                  <th class="header-cell">Template Name</th>
                  <th class="header-cell">Type</th>
                  <th class="header-cell">Count</th>
                  <th class="header-cell">Status</th>
                  <th class="header-cell">Created at</th>
                  <th class="header-cell">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="downloadItems.length === 0">
                  <td colspan="5" style="text-align: center;">No data available</td>
                </tr>
                <tr v-for="(item, index) in downloadItems" :key="index">
                  <td class="row-cell">{{ item.item.id }}</td>
                  <td class="row-cell">{{ item.templateName }}</td>
                  <td class="row-cell">{{ item.type }}</td>
                  <td class="row-cell">{{ item.count }}</td>
                  <td class="row-cell">
                    {{
                      item.flag == 2
                        ? "completed"
                        : "processing"
                    }}
                  </td>
                  <td class="row-cell">{{ item.item.created_at }}</td>
                  <td class="row-cell">
                    <v-icon title="Download Leads" :disabled="item.flag == 2 ? false : true" small
                      @click="donwnloadfile(item.file_url)" class="fas fa-download1">
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </div>
        </v-card-text>
        <v-card-actions class="modal-footer--sticky">
          <v-spacer></v-spacer>
          <v-btn color="light" @click="triggerClose(false)">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>



</template>

<script>
export default {
  data() {
    return {
      tabs: ["upload", "download"],
      snackbar: {
        show: false,
        timeout: 6000,
        text: "",
      },
    }
  },
  props: {
    downloadItems: Array,
    isShowDownloadPopup: Boolean,
    process_type: String,
  },
  methods: {
    typechange(data) {
      console.log(data, "ooooooooooooooooo")
      this.$emit("typechange", data);
    },
    triggerClose() {
      this.$emit("close-popup", false);
    },
    showSnackBar(message) {
      let scope = this;
      scope.snackbar.text = message;
      scope.snackbar.show = true;
      setTimeout(() => {
        scope.snackbar.text = "";
      }, scope.snackbar.timeout);
    },
    skipdatadownload(type, skipdata) {

      if (type === "csv") {
        // let scope = this; // Assuming 'this' context is correctly set

        let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
        csvContent += Object.keys(skipdata[0]).join(",") + "\r\n";

        skipdata.forEach(function (row) {
          let data1 = Object.values(row).map(elm => {
            if (typeof elm === 'string') {
              return elm.replace(/[~`!@#$%^&*()_+\-=[\]{}\\|:;”’<,>.?/]/g, " ");
            } else {
              return elm;
            }
          });

          let csvRow = data1.join(",");
          csvContent += csvRow + "\r\n";
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "skip_data.csv");
        document.body.appendChild(link);
        link.click();


      } else if (type === "txt") {
        let txtContent = "";
        for (const key in skipdata[0]) {
          let txt_tab = `${key} \t`;
          txtContent += `${txt_tab}`;
        }
        skipdata.forEach(function (rows) {
          let data = Object.values(rows);
          let row = data.join("\t");
          txtContent += `\n ${row}` + "\r";
        });
        var encodedUri1 =
          "data:text/plain;charset=utf-8,\uFEFF" +
          encodeURIComponent(txtContent);

        var link1 = document.createElement("a");
        link1.setAttribute("href", encodedUri1);
        link1.setAttribute(
          "download",
          "skip_" + `data.txt`
        );
        document.body.appendChild(link1);
        link1.click();
      }

    },
    donwnloadfile(file_url) {
      var apiInfo = JSON.parse(localStorage.apiInfo || "{}");
      if (this.process_type === "download") {
        file_url = apiInfo.portal_url + "/" + "download" + "/" + file_url
        const link = document.createElement("a");
        link.href = file_url;
        link.download = file_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        let import_id = file_url.item.id
        this.$store
          .dispatch("getskipData", { "import_id": import_id })
          .then((response) => {
            if (response.status === 200) {
              let details = JSON.parse(file_url.item.details)
              this.skipdatadownload(details.filetype, response.data.data)
            } else {
              this.showSnackBar("Skip data not found");
            }
          })

      }

    },

  },
};
</script>

<style>
.scroll-container {
  max-height: 450px;
  overflow-y: auto;
}

.hide-v-card {
  overflow-y: hidden !important;
}

.header-cell {
  padding: 25px 55px 2px 20px;
  border-bottom: 2px solid #e0e0e0;
  text-align: left;
  font-weight: bold;
  background-color: #f5f5f5;
}

.row-cell {
  padding: 25px 55px 2px 20px;
  border-bottom: 1px solid #e0e0e0;
}

.header-flx {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%
}

.btnclass {
  background-color: white !important;
  color: black !important
}

.select_type {
  margin: 20px
}
</style>
